import React from 'react';

import './LabelValueTable.css'

/**
 * A button inside the clue list item on the clues page for navigating:  either up, down, or delete.
 */
export const FormattedLabelsAndValues = (props ) => {

    const {labels, values, userWritten, className } = props;

    if (! Array.isArray(labels) || ! Array.isArray(values) || labels.length !== values.length) {
        return <div>Missing label-value pairs.</div>
    }

    let index = 0;
    const tableItems = props.labels.map( (label) => {
        const value = values[index];
        const byUser = userWritten ? userWritten[index] : false;
        const valueClass = "right-column" + (byUser ? " user-written" : " secondary-highlight");

        index++;
        return (
            <tr key={label}>
                <td className="left-column">{label}:</td>
                <td className={valueClass}><b>{value}</b>      </td>
            </tr>
        )
    });

    return (
        <div className={className}>
            <table className="no-side-margins">
                <tbody>
                   {tableItems}
                </tbody>
            </table>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/huntcomponents/FormattedLabelsAndValues.js